<template>
    <div class="LeaderboardPlayer" :class="{ isMe }">
        <div class="rank">
            {{ rank }}
        </div>
        <div class="avatar" :style="{ backgroundImage: `url(${avatar}), url(${fallbackAvatar})` }" />
        <div class="name"> {{ firstName }} {{ lastName }} </div>

        <div class="count">{{ correct }} {{ correct === 1 ? $t('point') : $t('points') }} </div>
        <div v-if="time" class="time"> {{ time }} sec </div>
    </div>
</template>

<script>
import fallbackAvatar from '@/assets/images/avatar.png';

export default {
    props: {
        avatar: {
            type: String
        },
        firstName: {
            type: String
        },
        lastName: {
            type: String
        },
        rank: {
            type: Number
        },
        correct: {
            type: Number
        },
        total: {
            type: Number
        },
        time: {
            type: Number
        },
        isMe: {
            type: Boolean
        }
    },
    created() {
        this.fallbackAvatar = fallbackAvatar;
    }
};
</script>

<style scoped lang="scss">
.LeaderboardPlayer {
    padding: 0.5em 1em;
    // border: 1px solid red;
    display: flex;
    align-items: center;

    &.isMe {
        background-color: rgba(black, 0.1);
    }
}
.rank {
    width: 3em;
}
.avatar {
    $size: 4em;
    width: $size;
    height: $size;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 50%;
    margin-right: 1em;
    border: 0.3em solid $dashboard-itemBackground;
}
.name {
    flex: 1;
    font-weight: 600;
    font-size: 120%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.count {
    margin-left: 1em;
}
.time {
    width: 5em;
    text-align: right;
}
</style>
